import { UPDATE_ACTIONABLE_SETTING } from '../../constant';

const initActionableSetting = () => {
  const setting = localStorage.getItem('ACTIONABLE_SETTING');
  if (setting) {
    return JSON.parse(setting);
  } else {
    const defaultSetting = {
      idleLogout: false,
      flashAlert: true,
      mute: false,
    };

    localStorage.setItem('ACTIONABLE_SETTING', JSON.stringify(defaultSetting));

    return defaultSetting;
  }
};

const ActionableSettingsReducer = (state = initActionableSetting(), action) => {
  const { type, data } = action;
  if (type === UPDATE_ACTIONABLE_SETTING) {
    return {
      ...state,
      ...data,
    };
  } else {
    return state;
  }
};

export { ActionableSettingsReducer };
